import axios from "../utils/axios";
import { buildFilterQueryString, buildSortingParams } from "../utils/query";

export const getProviders = async ({ offset, limit, filters, sortModel } = {}) => {
  const filterQueryString = buildFilterQueryString(filters);
  const sortingParams = buildSortingParams(sortModel);
  const queryParts = [limit != null && `limit=${limit}`, offset != null && `offset=${offset}`, filterQueryString, sortingParams].filter(Boolean);
  const url = `/providers?${queryParts.join("&")}`;
  const { data: providers } = await axios.get(url);
  return providers;
};

export const removeProvider = async (providerId) => {
  const { data: removedProvider } = await axios.delete(`/providers/${providerId}`);
  return removedProvider;
};

export const addProvider = async (provider) => {
  const { data: addedProvider } = await axios.post("/providers", {
    data: provider,
  });
  return addedProvider;
};

export const updateProvider = async ({ id, ...providerData }) => {
  const { data: updatedProvider } = await axios.put(`/providers/${id}`, {
    data: providerData,
  });
  return updatedProvider;
};
